// AI-Generated Code - 2026-03 - Placeholder for commercial release

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "wouter";

export default function PrivacyPolicyPage() {
  return (
    <div className="container max-w-3xl mx-auto py-10 px-4">
      <Card>
        <CardHeader>
          <CardTitle>Privacy Policy</CardTitle>
          <p className="text-sm text-muted-foreground">
            Last updated: {new Date().toISOString().split("T")[0]}
          </p>
        </CardHeader>
        <CardContent className="prose prose-slate dark:prose-invert max-w-none">
          <p className="text-muted-foreground">
            This is a placeholder. Before commercial release, replace this page with your full Privacy Policy drafted or reviewed by a lawyer. Required for GDPR/CCPA and general good practice.
          </p>
          <p className="text-muted-foreground mt-4">
            Typical sections include: what data you collect (account, scan URLs, cookies, logs), legal basis, how you use it, retention, sharing with third parties (e.g. Stripe, email provider), international transfers, user rights (access, rectification, deletion, portability, objection), cookies, security measures, and contact for privacy requests.
          </p>
          <Link href="/">
            <span className="text-primary hover:underline mt-6 inline-block">← Back to home</span>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
